<template>
  <div v-if="productData" class="col-12 mb-2 advCartRow">
    <div v-if="checkoutCart && !miniCart">
      <div class="text-center minicartItem checkoutCart">
        <div class="row" v-if="
            'options' in cartProduct &&
            'appliedBundles' in cartProduct.options &&
            cartProduct.options.appliedBundles.length > 0
          ">
          <div class="col-2 p-0 m-0"></div>
          <div class="col-10 p-0 m-0">
            <adv-cart-product-bundle-display
              class="col-12 p-0 m-0"
              :cart-product="cartProduct"
              :product-data="productData"
              style-type="smart"
            />
          </div>
        </div>
        <div class="row d-flex justify-content-center align-items-center">
          <div class="col-4 col-lg-3 minicart-item-thumb">
            <div class="thumbnail_container">
              <div class="thumbnail">
                <img class="img-fluid" :src="imageSrc" :alt="productData.productName"/>
              </div>
            </div>
          </div>
          <div class="col-8 col-lg-5 cart_item_info">
            <div class="row">
              <div class="col-12 cart_item_name">
                <span class="d-flex cart_item_code">{{t('product_code')}} :{{ productData.productId }}</span>
                <span class="cart_item_title">{{ productData.productName }}</span>
              </div>
            </div>
          </div>
          <div class="col-1 minicart-input-col d-flex justify-content-center align-items-center" v-if="!readOnly">
            <div class="row">
              <adv-cart-input-spinner
                class="quantitySpinner"
                :key="cartProduct.quantity + (cartProduct.freeQuantity || 0)"
                :product-code-id="cartProduct.productCodeId"
                :quantity="cartProduct.quantity"
                v-on:quantity-changed="updateProductQuantity">
              </adv-cart-input-spinner>
            </div>
          </div>
          <AdvCartProductCustomizationDisplayValues :product="cartProduct" />
          <div class="col-1 minicart-quantity d-flex justify-content-center align-items-center" v-if="readOnly">
                  <span>
                    {{ cartProduct.quantity }}
                  </span>
          </div>
          <div class="col-3 col-sm-offset-2 minicart-price d-flex end align-items-center">
            <span v-html="finalTotalPriceWithSign"></span>
          </div>
        </div>
        <adv-cart-product-bundle-display
          class="col-12"
          :cart-product="cartProduct"
          :product-data="productData"
        />
        <div class="col-6 minicart-input-col" v-if="!readOnly">
          <div class="row">
            <adv-cart-input-spinner
              class="quantitySpinner"
              :product-code-id="cartProduct.productCodeId"
              :quantity="cartProduct.quantity"
              v-on:quantity-changed="updateProductQuantity">
            </adv-cart-input-spinner>
          </div>
        </div>
        <AdvCartProductCustomizationDisplayValues :product="cartProduct" />
      </div>
    </div>
    <div v-if="miniCart">
      <div class="row minicart-item-row">
        <div class="col-12 text-center helpCartMsg m-3" v-show="cartError && !readOnly">
          <span><i class="ti-info-alt"></i> {{ cartError }}</span>
        </div>
        <div class="col-4">
          <div class="col-12 minicart-item-thumb">
            <div class="thumbnail_container">
              <div class="thumbnail">
                <img :src="imageSrc" :alt="productData.productName">
              </div>
            </div>
          </div>
        </div>
        <div class="col-8">
          <div class="col-12 minicart-item-title">
            <template v-if="
            'options' in cartProduct &&
            'appliedBundles' in cartProduct.options &&
            cartProduct.options.appliedBundles.length > 0
          ">
              <adv-cart-product-bundle-display
                class="col-12 p-0"
                :cart-product="cartProduct"
                :product-data="productData"
                :expanded="true"
                style-type="smart"
              />
            </template>
            <a :href="productData.productUrl">
              {{ productData.productName }}
            </a>
            <AdvCartProductCustomizationDisplayValues :product="cartProduct" />
          </div>
        </div>
        <div class="row d-flex justify-content-center align-items-center">
          <div class="col-2">
            <div class="minicart-item-price text-center ">
              <b><span v-html="finalPriceWithSign"></span></b>
            </div>
          </div>
          <div class="col-4 minicart-item-quantity" v-if="!readOnly">
            <adv-cart-input-spinner
              class="quantitySpinner"
              :key="cartProduct.quantity + (cartProduct.freeQuantity || 0)"
              :product-code-id="cartProduct.productCodeId"
              :quantity="cartProduct.quantity"
              v-on:quantity-changed="updateProductQuantity">
            </adv-cart-input-spinner>
          </div>
          <div class="col-6 offset-2 col-sm-4 col-md-3 minicart-item-quantity advSpinnerRow" v-if="readOnly">
            {{ cartProduct.quantity }}
          </div>
          <div class="col-1">
            <a href="#" v-on:click="removeProductFromCart" v-if="!readOnly" :disabled="!onlineStatus"
               class="action-item">
              <i class="lni lni-close"></i>
            </a>
          </div>
          <div class="col-3 col-sm-12 col-md-2 advCartRowTotal">
            <div class="advCart-discount-row d-none" v-show="productData.productHasDiscount">
              <small class="advCartDiscTtl">{{ t('discount') }}</small>
              <span class="advCartDiscPerc">
              <b>{{ productData.productDisclosure }}</b>
            </span>
            </div>
            <span v-show="productData.productHasDiscount" class="advCartPrevPrice d-none"
                  v-html="originalTotalPriceWithSign"></span>
            <span class="advCartFinalPrice" v-html="finalTotalPriceWithSign"></span>
          </div>
        </div>
      </div>
      <div v-show="productCodeData.productCodeAttributes.length > 0" class="col-xs-12 advCartRowAttr">
          <span>
            {{ productCodeAttributes }}
          </span>
      </div>
    </div>
    <div v-if="!miniCart && !checkoutCart">
      <div class="row minicart-item-row">
        <div class="col-12 text-center helpCartMsg m-3" v-show="cartError && !readOnly">
          <span><i class="ti-info-alt"></i> {{ cartError }}</span>
        </div>
        <div class="col-4 col-md-2 col-xl-2 minicart-item-thumb">
          <div class="thumbnail_container">
            <div class="thumbnail">
              <img :src="imageSrc" :alt="productData.productName">
            </div>
          </div>
        </div>
        <div class="col-6 col-sm-4 col-md-2 minicart-item-title text-center ">
          <span class="product-code-row">
            {{t('product_code')}} :
            {{ productData.productId }}
          </span>
          <a :href="productData.productUrl">
            {{ productData.productName }}
          </a>
          <AdvCartProductCustomizationDisplayValues :product="cartProduct" />
        </div>
        <div class="col-3 col-sm-2 col-md-2">
          <div class="minicart-item-price text-center ">
            <b><span v-html="finalPriceWithSign"></span></b>
          </div>
        </div>
        <div class="col-4 col-md-2 minicart-item-quantity" v-if="!readOnly">
          <adv-cart-input-spinner
            class="quantitySpinner"
            :product-code-id="cartProduct.productCodeId"
            :quantity="cartProduct.quantity"
            v-on:quantity-changed="updateProductQuantity">
          </adv-cart-input-spinner>
        </div>
        <div class="col-6 offset-2 col-sm-4 col-md-3 minicart-item-quantity advSpinnerRow" v-if="readOnly">
          {{ cartProduct.quantity }}
        </div>
        <div class="col-2">
          <a href="#" v-on:click="removeProductFromCart"  v-if="!readOnly" :disabled="!onlineStatus" class="action-item">
            <i class="lni lni-close"></i>
          </a>
        </div>
        <div class="col-3 col-sm-12 col-md-2 advCartRowTotal">
          <div class="advCart-discount-row d-none" v-show="productData.productHasDiscount" >
            <small class="advCartDiscTtl">{{ t('discount') }}</small>
            <span class="advCartDiscPerc">
              <b>{{ productData.productDisclosure }}</b>
            </span>
          </div>
          <span v-show="productData.productHasDiscount" class="advCartPrevPrice d-none" v-html="originalTotalPriceWithSign"></span>
          <span class="advCartFinalPrice" v-html="finalTotalPriceWithSign"></span>
        </div>
      </div>
      <div v-show="productCodeData.productCodeAttributes.length > 0" class="col-xs-12 advCartRowAttr">
          <span>
            {{ productCodeAttributes }}
          </span>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../../vue/store'
import onlineMixin from './mixins/onlineMixin'
import AdvCartInputSpinner from './AdvCartInputSpinner'
import AdvCartProductCustomizationDisplayValues
  from './cartProductCustomizations/AdvCartProductCustomizationDisplayValues.vue'
import AdvCartProductBundleDisplay from './AdvCartProductBundleDisplay.vue'

export default {
  name: 'AdvCartProductRow',
  components: {
    AdvCartProductCustomizationDisplayValues,
    AdvCartProductBundleDisplay,
    AdvCartInputSpinner
  },
  mixins: [onlineMixin],
  props: {
    checkoutCart: {
      type: Boolean,
      default: false
    },
    miniCart: {
      type: Boolean,
      default: false
    },
    cartProduct: {
      type: Object
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    disableProductLinks: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      version: '0.0.1'
    }
  },
  computed: {
    cartError () {
      return store.getters.cartProductErrorMsg(this.cartProduct.productCodeId)
    },
    productCodeData () {
      return store.getters.getSelectedProductCodeByCodeId(this.cartProduct.productCodeId)
    },
    originalTotalPriceWithSign () {
      const price = this.productData.productOldPrice * this.cartProduct.quantity * store.getters.getSelectedCurrency.rate
      return price.toFixed(2) + store.getters.getSelectedCurrency.symbol
    },
    finalPriceWithSign () {
      return (this.productData.productFinalPrice * store.getters.getSelectedCurrency.rate).toFixed(2) + store.getters.getSelectedCurrency.symbol
    },
    finalTotalPriceWithSign () {
      const price = this.productData.productFinalPrice * this.cartProduct.quantity * store.getters.getSelectedCurrency.rate
      return price.toFixed(2) + store.getters.getSelectedCurrency.symbol
    },
    productData () {
      const productData = store.getters.getProductById(this.cartProduct.productId)
      const cartProductData = store.getters.getCartProductById(this.cartProduct.productId)
      return {
        ...productData,
        ...cartProductData
      }
    },
    imageSrc () {
      return this.productData.hasOwnProperty('images') ? this.productData.images[this.cartProduct.productCodeId].find(item => item.is_main === '1')['small'] : store.getters.noImage
    },
    productCodeAttributes () {
      return this.productCodeData.productCodeAttributes.reduce((acc, item) => {
        if (acc !== '') {
          acc += ' - '
        }

        acc += store.getters.attributeName(item)
        return acc
      }, '')
    },
    selectedCurrency () {
      return store.getters.getSelectedCurrency
    }
  },
  methods: {
    removeProductFromCart () {
      const cartPayload = {
        productCodeId: this.cartProduct.productCodeId,
        quantity: 0
      }
      if ('cartProductCustomizations' in this.cartProduct.options) {
        cartPayload['cartProductCustomizations'] = this.cartProduct.options.cartProductCustomizations
      }
      store.dispatch('addToCartClicked', cartPayload)
    },
    updateProductQuantity (quantity) {
      const cartPayload = {
        productCodeId: this.cartProduct.productCodeId,
        quantity: quantity + (this.cartProduct.freeQuantity || 0)
      }
      if ('cartProductCustomizations' in this.cartProduct.options) {
        cartPayload['cartProductCustomizations'] = this.cartProduct.options.cartProductCustomizations
      }
      store.dispatch('addToCartClicked', cartPayload)
    }
  }
}
</script>
